<template>
    <div class="sports-selection-tabs">
        <div class="searchWrap-panel" :class="{'fullWidth' : !searchCasinoHide}">
            <ul class="nav nav-pills" id="pills-tab" role="tablist">
                <li v-for="(menuItem, m_index) in menusList" :key="m_index" class="nav-item" role="presentation">
                    <button @click="clickOnMenuItem(menuItem)" class="nav-link"
                        :class="{ 'active': selectedMenu.id == menuItem.id }" id="pills-home-tab" data-bs-toggle="pill"
                        data-bs-target="#popular" type="button" role="tab" aria-controls="popular" aria-selected="true">
                        {{ menuItem.title }}
                    </button>
                </li>
            </ul>
            
            <div class="searchWrap-card" :class="{'open' : showSearch}" v-if="searchCasinoHide">
                <input class="searchWrap-inp" ref="searchInput" type="text" @click="closeSearch"  placeholder="Search..." v-model="searchText">
                    <span class="searchWrap-icon" @click="openSearch">
                    <img src="@/assets/images/search.png" alt="">
                    </span>
                <span class="searchWrap-close" @click="closeSearch">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.2894 13.5254C15.6814 13.9167 15.6807 14.552 15.2879 14.9424L14.9412 15.2871C14.5505 15.6754 13.9195 15.6747 13.5297 15.2856L8.69883 10.463C8.3078 10.0726 7.67428 10.0733 7.28417 10.4646L2.47458 15.2886C2.0834 15.681 1.44776 15.6805 1.05717 15.2875L0.712892 14.9412C0.324623 14.5505 0.325309 13.9195 0.714427 13.5297L5.52877 8.70711C5.91872 8.31648 5.91845 7.68379 5.52817 7.2935L0.708984 2.47432C0.317728 2.08306 0.318568 1.44845 0.71086 1.05823L1.0577 0.713224C1.44873 0.32426 2.08086 0.325334 2.47057 0.715625L7.28356 5.53583C7.674 5.92686 8.30757 5.92709 8.6983 5.53636L13.5238 0.710875C13.9158 0.318882 14.5518 0.320573 14.9418 0.714643L15.2821 1.05862C15.6689 1.4496 15.6674 2.07957 15.2787 2.46869L10.4604 7.29221C10.0699 7.68306 10.0704 8.31646 10.4614 8.70673L15.2894 13.5254Z" fill="currentColor"/>
                    </svg>

                </span>
            </div>
        </div>

        <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade show active" id="popular" role="tabpanel" aria-labelledby="pills-home-tab">
                <div class="ng-star-inserted-wrapper">
                    <div v-for="(gameItem, g_index) in filteredGames" :key="g_index" class="position-relative">
                        <a @click="clickOnGamestButton(gameItem)"> 
                            <div class="clip"></div>
                            <div class="clip2">
                                <img v-if="gameItem.image != null" :src="gameItem?.image" class="casinoImg" />
                                <img v-else src="@/assets/images/poker-min.png" class="casinoImg">
                            </div>
                            <div class="casino-bottom">{{ gameItem?.game_name }}</div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div ref="games_pop_1_modal" style="display: none;" data-bs-toggle="modal" data-bs-target="#static_games_pop_1"></div>
    <div ref="games_pop_2_modal" style="display: none;" data-bs-toggle="modal" data-bs-target="#static_games_pop_2"></div>
    <div ref="iframe_pop_modal_home" style="display: none;" data-bs-toggle="modal" data-bs-target="#iframe_pop_modal_home"></div>

    <div class="modal fade game-play-modal" data-bs-backdrop="static" data-bs-keyboard="false"
        id="iframe_pop_modal_home" tabindex="-1" aria-labelledby="iframePopModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-fullscreen" style="max-width: 100%;">
            <IFrameModal @close-modal="openIframeModal = false" @error-modal="showErrorModalFunc"
                @success-modal="showSuccessModalFunc" v-if="openIframeModal" />
        </div>
    </div>
    <AgeConfLoginModal></AgeConfLoginModal>
</template>

<script>
import { Modal } from "bootstrap";
import IFrameModal from "./IFrameModal";
import { setGameItem } from "@/shared/constants/shared-data";
import AgeConfLoginModal from '@/shared/components/modal/AgeConfirmationLoginModal.vue';

export default {
    data() {
        return {
            gamesList: [],
            menusList: [],
            liveCasinoSection: null,
            openIframeModal:false,
            showSearch:false,
            searchText: '',
        }
    },
    props:['currentSectionType','checkRerender','searchCasinoHide'],
    components:{
        IFrameModal,
        AgeConfLoginModal
    },
    mounted(){
        this.liveCasinoSection = this.$store.getters?.gamesData?.sections?.find(item => item.slug == this.currentSectionType);
        this.menusList = this.liveCasinoSection?.menus;
        if (this.menusList && this.menuList?.length != 0) {
            this.selectedMenu = this.menusList[0];
            this.gamesList = this.selectedMenu?.games;
            
        } else if(this.liveCasinoSection?.games?.length) {
            this.gamesList = this.liveCasinoSection?.games;
        }
    },
    computed: {
        filteredGames() {
            return this.gamesList.filter(game =>
                game.game_name.toLowerCase().includes(this.searchText.toLowerCase())
            )
        }
    },
    methods: {
        openSearch() {
        this.showSearch = true;
        this.$nextTick(() => {
                this.$refs.searchInput.focus();
            });
        },
        closeSearch() {
        this.searchText = '';
        this.showSearch = false;
        },
        clickOnMenuItem(menuItem) {
            this.$emit('change-render', false)
            this.gamesList = [];
            this.selectedMenu = menuItem;
            this.gamesList = this.selectedMenu?.games;
        },
        clickOnGamestButton(item) {
            if (this.checkIsLogin()) {
                this.openGamesPopup(item);
            } else {
                const modal = new Modal(document.getElementById('ageconfirmationModal'));
                modal.show();
            }
        },
        checkIsLogin() {
            return this.$store.getters.isAuthenticated;
        },
        openGamesPopup(gameItem) {
            setGameItem(gameItem);
            switch (this.userData().currency) {
                case 1:
                    if (gameItem.only_hkd == 1) {
                        this.$refs.games_pop_1_modal.click();
                    } else if (gameItem.only_hkd == 0) {
                        this.openIframeModal = true;
                        this.$refs.iframe_pop_modal_home.click();
                    }
                    break;
                case 2:
                    if (gameItem.only_hkd == 1) {
                        this.$refs.games_pop_1_modal.click();
                    } else if (gameItem.only_hkd == 0) {
                        this.$refs.games_pop_2_modal.click();
                    }
                    break;
                case 3 || 4:
                    this.openIframeModal = true;
                    this.$refs.iframe_pop_modal_home.click();
                    break;
            }
        },
        userData() {
            return this.$store.getters.stateUser;
        },
        showErrorModalFunc(message) {
            this.$emit('error-modal', message)
        },
        showSuccessModalFunc(message) {
            this.$emit('success-modal', message)
        },
    }
}
</script>

<style></style>